import { render } from "./Modal.vue?vue&type=template&id=6db40f0c&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=6db40f0c&scoped=true&lang=css"

import exportComponent from "/builds/tapetum1/tapetum-landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db40f0c"]])

export default __exports__